import { IMealtime } from '../../../types/mealtimes.types';
import { createMealtimeCategories } from '../../../api/createMealtimeCategories/createMealtimeCategories';
import { ISectionFormTypes } from '../SectionModal';

export const updateMealtimes = async (
  menuId: string,
  sectionId: string,
  selectedMealtimes: ISectionFormTypes['mealtimes'],
  mealtimes: IMealtime[],
): Promise<void> => {
  await Promise.all(
    Object.keys(selectedMealtimes).map((mealtimeId) => {
      const mealtime = mealtimes.find((m) => m.mealtime_id === mealtimeId);
      const mealtimeCategoryIds = mealtime.categories.map((category) => category.category_id);
      // if mealtime remains unchanged, do nothing
      if (!selectedMealtimes[mealtimeId] && !mealtimeCategoryIds.includes(sectionId)) {
        return Promise.resolve();
      } else {
        // if mealtime is not selected, remove it from the update request, else add it
        if (!selectedMealtimes[mealtimeId]) {
          return createMealtimeCategories(
            menuId,
            mealtimeId,
            mealtimeCategoryIds.filter((categoryId) => categoryId !== sectionId),
          );
        } else {
          const categoryIds = mealtimeCategoryIds.includes(sectionId)
            ? mealtimeCategoryIds
            : [...mealtimeCategoryIds, sectionId];
          return createMealtimeCategories(menuId, mealtimeId, categoryIds);
        }
      }
    }),
  );
};
